import { negate } from "lodash";
import { DateTime } from "luxon";

// accepts number and returns boolean using luxon to validate if it is a valid date
export function isValidISODate(date: string) {
  return DateTime.fromISO(date).isValid;
}

export const isInvalidISODate = negate(isValidISODate);
